const keptVisible = new WeakSet<HTMLElement>();

export namespace Aria {
    /** Remove aria-hidden="true" if present (e.g. after NgbModal hides body siblings). */
    export function setVisible(element: HTMLElement): void {
        if (element.getAttribute("aria-hidden") === "true") {
            element.removeAttribute("aria-hidden");
        }
    }

    /**
     * NgbModal (and similar) set aria-hidden on body siblings while open, which silences
     * live regions and aria-describedby targets. Watch the element and strip aria-hidden
     * whenever it is applied.
     */
    export function keepVisible(element: HTMLElement): void {
        if (keptVisible.has(element)) return;
        keptVisible.add(element);

        Aria.setVisible(element);
        const observer = new MutationObserver(() => Aria.setVisible(element));
        observer.observe(element, { attributes: true, attributeFilter: ["aria-hidden"] });
    }
}
